// extracted by css-extract-rspack-plugin
export default {"transformItem":"iGnr2"};